import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCausativeAgents.success: {
            return action.payload;
        }

        case constants.getCausativeAgents.error: {
            return initialState;
        }

        case constants.getCausativeAgents.try: {
            return {};
        }

        default:
            return state;
    }
}